import React, { useState } from 'react'
import { Link } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import ProductCard from './product-card'
import useGetAllCategory from '../hooks/useGetAllCategory'
import useGetAllProduct from '../hooks/useGetAllProduct'

export default function FeaturedProducts({ title, products, ids, sale_ids, collection_ids }) {
    const allProduct = useGetAllProduct()
    const allCategory = useGetAllCategory()
    const [category, setCategory] = useState(allCategory[0].node)

    const getProductById = (id) => allProduct.find(({ node }) => node.productId === id).node
    const byCategory = (product) => product.shop_categories[0].id === category.categoryId
    const toProductCard = (product) => <ProductCard product={product} key={`featured-product-grid-${product?.id}`} />

    products = products ? products : ids.map(getProductById)
    const sale_products = sale_ids.map(getProductById)
    const collection_products = collection_ids.map(getProductById)

    return (
        <Container fluid className="bg-light pb-5 px-0">
            <Container>
                <h2 className="text-uppercase pt-5 mb-4">
                    {title ? title : 'Featured'}
                </h2>

                {/* CATEGORY SELECT BAR */}
                <Row className="gap-5 mb-4 flex-nowrap overflow-auto">
                    {allCategory.map(({ node }, i) => {
                        const { name, slug } = node
                        return (
                            <Col key={`featured-products-category-nav-${slug}-${i}`} xs='auto'>
                                <Button
                                    variant=''
                                    onClick={() => setCategory(node)}
                                    // must do subtractive bordering because buttons (elements with class 'btn') have all borders by default
                                    className={`fw-bold text-uppercase px-0 ${node === category ? 'border border-top-0 border-end-0 border-start-0 border-primary border-5' : 'text-secondary'}`}
                                >
                                    {name}
                                </Button>
                            </Col>
                        )
                    })}
                    <Col xs='auto'>
                        <Button
                            variant=''
                            onClick={() => setCategory({ name: 'Sale', slug: 'sale' })}
                            // must do subtractive bordering because buttons (elements with class 'btn') have all borders by default
                            className={`fw-bold text-uppercase px-0 ${'Sale' === category.name ? 'border border-top-0 border-end-0 border-start-0 border-primary border-5' : 'text-secondary'}`}
                        >
                            Sale
                        </Button>
                    </Col>
                    <Col xs='auto'>
                        <Button
                            variant=''
                            onClick={() => setCategory({ name: 'Collections', slug: 'collections' })}
                            // must do subtractive bordering because buttons (elements with class 'btn') have all borders by default
                            className={`fw-bold text-uppercase px-0 ${'Collections' === category.name ? 'border border-top-0 border-end-0 border-start-0 border-primary border-5' : 'text-secondary'}`}
                        >
                            Collections
                        </Button>
                    </Col>
                </Row>

                {/* PRODUCT CARDS */}
                <Row className="mb-4">
                    {
                        category.name === 'Sale' ? sale_products.map(toProductCard)
                            :
                            category.name === 'Collections' ? collection_products.map(toProductCard)
                                :
                                products.filter(byCategory).map(toProductCard)
                    }
                </Row>

                {/* BUTTON (LINK) TO CATEGORY (PLP) */}
                <div className="text-center">
                    <Link to={category.slug} className="d-inline-block ff-primary text-black text-uppercase border border-black border-2 px-5 py-2" style={{ fontSize: 18 }}>
                        VIEW ALL {category.name}
                    </Link>
                </div>
            </Container>
        </Container>
    )
}